import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { stripeSession } from "../../../participant/pages/participantSettingsPage/services";
import { getErrorMessageFromRequestError } from "../../helpers/messages/request";
import { setError, setFetching } from "../../request/actions/requestActions";
import { openSubscriptionModal } from "../../../auth/actions/login.actions";

export const StripeCustomerPortalButton = ({
  profileId,
  text,
  variant,
  customCss,
  color,
  endIcon,
}) => {
  const dispatch = useDispatch();
  const { request } = useSelector((state) => {
    return {
      request: state.request.request,
    };
  });

  const getStripeSession = async () => {
    dispatch(setFetching({ isFetching: true }));
    dispatch(openSubscriptionModal(false));
    try {
      const { data } = await stripeSession(profileId);
      const { url } = data.data;
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);
      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

  const handleClick = () => {
    if (profileId) getStripeSession();
  };

  return (
    <>
      <Button
        color={color}
        variant={variant}
        onClick={handleClick}
        disabled={request.isFetching}
        className={customCss}
        endIcon={endIcon}
      >
        {text}
      </Button>
    </>
  );
};

StripeCustomerPortalButton.propTypes = {
  profileId: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.string,
  customCss: PropTypes.string,
  color: PropTypes.string,
  endIcon: PropTypes.element,
};

StripeCustomerPortalButton.defaultProps = {
  profileId: "",
  text: "Payment Details",
  variant: "contained",
  customCss: null,
  color: "primary",
  endIcon: null,
};
